<template>
    <div class="story-maker-sticker story-maker-sticker-countdown" :class="{edit: isSelected}" @click.self="finish">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')" @click="stickerInstance.nextColor">
        <!-- <p class="text-finish" @click="finish">Terminé</p> -->
        <div 
            class="sticker sticker-countdown"
            :class="[`color-${stickerInstance.data.color.slice(1).toUpperCase()}`]"
            :style="{ 
                backgroundColor: stickerInstance.data.color,
        }"
        >
            <div class="countdown-header" v-if="isSelected || stickerInstance.data.name">
                <textarea 
                    cols="20" 
                    rows="2" 
                    wrap="hard" 
                    maxlength="100"
                    :placeholder="$t('dash.post-creator.story.countdown-name')"
                    v-model="stickerInstance.data.name" 
                    :readonly="!isSelected" 
                    @input="autoGrow" 
                    ref="input_countdown_name"
                ></textarea>
            </div>
            <div class="countdown" @click.stop="clickDate">
                <template v-if="parseInt(countdownData.months) > 0">
                    <div class="data months">
                        <div class="values">
                            <div class="value">{{ countdownData.months[0] }}</div>
                            <div class="value">{{ countdownData.months[1] }}</div>
                        </div>
                        <p>{{ $t('dash.post-creator.story.countdown-months') }}</p>
                    </div>
                    <div class="separator">:</div>
                </template>
                <template v-if="parseInt(countdownData.days) > 0 || parseInt(countdownData.months) > 0">
                    <div class="data days">
                        <div class="values">
                            <div class="value">{{ countdownData.days[0] }}</div>
                            <div class="value">{{ countdownData.days[1] }}</div>
                        </div>
                        <p>{{ $t('dash.post-creator.story.countdown-days') }}</p>
                    </div>
                    <div class="separator">:</div>
                </template>
                <div class="data hours">
                    <div class="values">
                        <div class="value">{{ countdownData.hours[0] }}</div>
                        <div class="value">{{ countdownData.hours[1] }}</div>
                    </div>
                    <p>{{ $t('dash.post-creator.story.countdown-hours') }}</p>
                </div>

                <template v-if="parseInt(countdownData.months) <= 0">
                    <div class="separator">:</div>
                    <div class="data hours">
                        <div class="values">
                            <div class="value">{{ countdownData.minutes[0] }}</div>
                            <div class="value">{{ countdownData.minutes[1] }}</div>
                        </div>
                        <p>{{ $t('dash.post-creator.story.countdown-minutes') }}</p>
                    </div>
                </template>
                <template v-if="parseInt(countdownData.days) <= 0 && parseInt(countdownData.months) <= 0">
                    <div class="separator">:</div>
                    <div class="data hours">
                        <div class="values">
                            <div class="value">{{ countdownData.secondes[0] }}</div>
                            <div class="value">{{ countdownData.secondes[1] }}</div>
                        </div>
                        <p>{{ $t('dash.post-creator.story.countdown-seconds') }}</p>
                    </div>
                </template>
            </div>
          
        </div>


        <div v-if="showPicker && isSelected" class="menu" ref="menu_countdown">
            <div class="header-menu">
                <p>{{ $t('dash.post-creator.story.countdown-choose-date') }}</p>
            </div>
            <div class="content">
                
                <div class="form">
                    <div class="container-input">
                        <div class="input input-date">
                            <i class="fa-regular fa-calendar"></i>
                            <p>{{ stickerInstance.dateLabel }}</p>
                            <input type="date" :value="stickerInstance.YYYYMMDD" @change="inputDateChange" @click="(e)=>e.target.showPicker()" :min="new Date().toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')">
                        </div>

                        <template v-if="!stickerInstance.data.allDay">
                            <p class="separator">{{ $t('dash.post-creator.story.countdown-at') }}</p>
                            <div class="input input-time">
                                <input placeholder="00" @change="inputHoursChange" @keydown="onlyDigits" @paste.prevent :value="stickerInstance.hours.toString()" maxlength="2">
                            </div>
                            <p class="separator">:</p>
                            <div class="input input-time">
                                <input placeholder="00" @change="inputMinutesChange" @keydown="onlyDigits" @paste.prevent :value="stickerInstance.minutes.toString()" maxlength="2">
                            </div>
                        </template>
                    </div>
                    <div class="allDay">
                        <label for="allDay">{{ $t('dash.post-creator.story.countdown-all-day') }}</label>
                        <ComponentSwitch :value="stickerInstance.data.allDay" :onChange="changeSwitchAllDay" :id="'switch-countdown-menu'" size="m"/>
                    </div>


                </div>
            
            </div>
            
        </div>

    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import { formatDateToYYYYMMDD } from '@/utils/Date.js'

    const colorsHeader = ["#FFFFFF","#0C0F14", "#FF0466", "#E70AC9", "#8037FC", "#FE700A", "#00D357", "#0D97FD"]
    
    export default {
        components: {
            ComponentSwitch
        },

        props: {
            id: Number | String,
            stickerInstance: {
                type: Object,
                required: true
            },
            isSelected: Boolean,
        },


        beforeDestroy() {
            clearInterval(this._timer)
        },

        watch: {
            isSelected: {
                handler(val) {
                    if (val) clearInterval(this._timer)
                    else this._startTimer()
                },
                immediate: true
            },
        },

        data() {
            return {
                showPicker: false,
                tick: 0,
                _timer: null,
            }
        },

        computed: {
            countdownData() {
                this.tick // dépendance réactive
                return this.stickerInstance.countdownData
            },
        },

        methods: {
            finish(event) {
                 this.$emit('unselect')
            },

            _startTimer() {
                clearInterval(this._timer)
                this._timer = setInterval(() => { this.tick++ }, 1000)
            },

            inputDateChange(e) {
                const [year, month, day] = e.target.value.split('-')
                const newDate = new Date(this.stickerInstance.data.date)
                newDate.setFullYear(Number(year))
                newDate.setMonth(Number(month) - 1)
                newDate.setDate(Number(day))
                this.$set(this.stickerInstance.data, 'date', newDate)
            },

            onlyDigits(e) {
                const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']
                if (!allowed.includes(e.key) && !/^\d$/.test(e.key)) e.preventDefault()
            },

            inputHoursChange(e) {
                const raw = e.target.value.replace(/\D/g, '')
                const hours = Math.min(23, Math.max(0, Number(raw)))
                const newDate = new Date(this.stickerInstance.data.date)
                newDate.setHours(hours)
                this.$set(this.stickerInstance.data, 'date', newDate)
            },

            inputMinutesChange(e) {
                const raw = e.target.value.replace(/\D/g, '')
                const minutes = Math.min(59, Math.max(0, Number(raw)))
                const newDate = new Date(this.stickerInstance.data.date)
                newDate.setMinutes(minutes)
                this.$set(this.stickerInstance.data, 'date', newDate)
            },

            focusAtEnd() {

                try {
                    const element = this.$refs[`input_countdown_name`]

                    const range = document.createRange();
                    const selection = window.getSelection();

                    range.selectNodeContents(element);
                    range.collapse(false);

                    selection.removeAllRanges();
                    selection.addRange(range);

                    // Donnez le focus à l'élément
                    element.focus();
                } catch (error) {
                    
                }

            },

            clickDate() {
                
                if(this.isSelected) {
                    this.showPicker = true
                }
            },

            changeSwitchAllDay(value) {
                this.stickerInstance.data.allDay = value

                if (!value) {
                    const now = new Date();
                    this.stickerInstance.data.date.setHours(now.getHours());
                    this.stickerInstance.data.date.setMinutes(now.getMinutes() + 10);
                }
            },

            autoGrow() {
            
                let element = this.$refs.input_countdown_name
                console.log("autoGrow",element)
            
                element.style.height = "5px";
                element.style.height = (element.scrollHeight) + "px";
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>